import axios from "axios"

export const AddCampaigns = async (payload, token)=>{
    try {
    const res = await axios.post("dialer/create-campaigns/", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
}

export const EditCampaigns = async (payload, id, token)=>{
    try {
    const res = await axios.patch(`dialer/campaigns/${id}/`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
}

export const deleteCampaign = async (id, token) => {
  try {
    const res = await axios.delete(
      `dialer/campaigns/${id}/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const changeStatus = async (id, payload, token, isTc = false) => {
  try {
    const url = isTc ? `dialer/telecaller-campaigns/${id}/` : `dialer/campaigns/${id}/`;
    const res = await axios.patch(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
}

// Whatsapp Campaigns Apis

export const AddWhatsappCampaign = async (payload, token)=>{
    try {
    const res = await axios.post("dialer/whatsapp-campaigns/", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
}

export const EditWhatsappCampaign = async (payload, id, token)=>{
    try {
    const res = await axios.patch(`dialer/whatsapp-campaigns/?id=${id}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
}
export const changeWhatsappCampaignStatus = async (id, payload, token) => {
  try {
    const url = `dialer/whatsapp-campaigns/?id=${id}`;
    const res = await axios.patch(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
}

export const deleteWhatsappCampaign = async (id, token) => {
  try {
    const res = await axios.delete(
      `dialer/whatsapp-campaigns/?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

// SMS Campaigns Apis

export const AddSmsCampaign = async (payload, token)=>{
    try {
    const res = await axios.post("dialer/sms-campaigns/", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
}

export const EditSmsCampaign = async (payload, id, token)=>{
    try {
    const res = await axios.patch(`dialer/sms-campaigns/?id=${id}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
}
export const changeSmsCampaignStatus = async (id, payload, token) => {
  try {
    const url = `dialer/sms-campaigns/?id=${id}`;
    const res = await axios.patch(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
}

export const deleteSmsCampaign = async (id, token) => {
  try {
    const res = await axios.delete(
      `dialer/sms-campaigns/?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};


export const fetchPortfolioMessageTemplates = async (token, portfolioId, channel) => {
    try {
        const url = channel ? `/dialer/message-templates/portfolio/${portfolioId}/?channel=${channel}` : `/dialer/message-templates/portfolio/${portfolioId}/`;
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // console.log(res, "====================PortfolioMessageTemplates============");
        return res;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            throw err.response?.data?.message || err.message || "Failed to fetch portfolio campaigns";
        } else {
            throw err;
        }
    }
};